import EventEmitter from 'events';

/**
 * FIXME(robin):
 * Documentation
    this.emit('log', line);
    this.emit('uartDidTransmit', index, data);
    this.emit('linDidTransmit', index, data);
    this.emit('updateOutputValue', index, type, value); // propagate that a new output value is available
    this.emit('updatePlatformCopyConfiguration', configId, index, buffer); // propagate that a new platform configuration value is available
    this.emit('uartDidReceive', index, buffer);
 */
export class Bridge extends EventEmitter {
  async instantiate() {
    throw new Error('Must be implemented by sub-class');
  }

  initialize() {
    throw new Error('Must be implemented by sub-class');
  }

  start() {
    throw new Error('Must be implemented by sub-class');
  }

  stop() {
    throw new Error('Must be implemented by sub-class');
  }

  async reset() {
    this.stop();
    await this.instantiate();
    this.initialize();
    this.start();
  }

  isDisplayInvalidated() {
    throw new Error('Must be implemented by sub-class');
  }

  getDisplayBuffer() {
    throw new Error('Must be implemented by sub-class');
  }

  setButtonState(/*type, state*/) {
    throw new Error('Must be implemented by sub-class');
  }

  getSensorConversion(/*nr, subIndex*/) {
    throw new Error('Must be implemented by sub-class');
  }

  setInputValueForType(/*index, type, value*/) {
    throw new Error('Must be implemented by sub-class');
  }

  isOutputInvalidated() {
    throw new Error('Must be implemented by sub-class');
  }

  getOutputValueAndType(/*index*/) {
    throw new Error('Must be implemented by sub-class');
  }

  sendUartData(/*index, buffer*/) {
    throw new Error('Must be implemented by sub-class');
  }

  sendLinData(/*index, buffer*/) {
    throw new Error('Must be implemented by sub-class');
  }
}
